import ColorFactory from "../factories/ColorFactory";
import webase from "../app/model";

export default class ComponentFactory {

    constructor() {
        this.colorFactory = new ColorFactory()
        this.tempImageUrl = 'https://images.unsplash.com/photo-1540390769625-2fc3f8b1d50c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxMjM5NjJ8MHwxfHNlYXJjaHwxNHx8bW91bnRhaW5zfGVufDB8MHx8fDE2NzUxOTc4MjY&ixlib=rb-4.0.3&q=80&w=1080'
    }

    newComponent(componentType) {
        let childComponent = null

        if (componentType === 'Button') {
            childComponent = this.createButton(['px-8', 'py-2', 'rounded', 'border'])
        } else if (componentType === 'Header') {
            childComponent = this.createHeader(['text-2xl', 'tracking-tight'])
        } else if (componentType === 'Label') {
            childComponent = this.createLabel([])
        } else if (componentType === 'Text') {
            childComponent = this.createText(['w-full'])
        } else if (componentType === 'Link') {
            childComponent = this.createLink(['p-2'], 'Link', '#')
        } else if (componentType === 'Icon') {
            childComponent = this.createFAIcon(['fas','fa-icons','text-2xl'])
        } else if (componentType === 'Icon Link') {
            let linkClasses = ['mx-1', 'inline-flex', 'justify-center', 'items-center', 'w-10', 'h-10', 'bg-gray-100', 'rounded']
            let iconClasses = ['fas','fa-icons']
            childComponent = this.createIconLink(linkClasses, iconClasses, '#')
        } else if (componentType === 'Image') {
            childComponent = this.createImageComponent(['w-full', 'object-cover'], this.tempImageUrl)
        } else if (componentType === 'Row Container') {
            childComponent = this.createComponent(['flex', 'flex-row', 'w-full'])
        } else if (componentType === 'Column Container') {
            childComponent = this.createComponent(['flex', 'flex-col', 'w-full'])
        } else if (componentType === 'Marquee Container') {
            childComponent = this.createMarqueeComponent([])
        } else {
            // TODO: need to add List gear and this may need to go away
            childComponent = this.createComponent(['flex', 'flex-row', 'w-full'])
        }

        return childComponent
    }

    createComponent(classes) {
        return this.createContainerComponent('FlexContainer', classes)
    }

    createMarqueeComponent(classes) {
        let container = this.createContainerComponent('MarqueeContainer', classes)
        container.options = {
            play: false,
            orientation: 'horizontal',
            direction: 'left',
            duration: '50'
        }
        container.children.push(this.createContainerComponent('FlexContainer', ['flex']))
        container.children.push(this.createContainerComponent('FlexContainer', ['flex']))
        container.children.push(this.createContainerComponent('FlexContainer', ['flex']))
        return container
    }

    createViewItemComponent(view, classes) {
        let container = this.createContainerComponent('DataViewItem', classes)
        container.view = view.id

        // NOTE: this is not a great coupling using AppManager here
        let field = webase.managers.app.getNameOrTitleField(view.model_id)

        if(field) {
            let header = this.createHeader(['text-3xl', 'font-bold', 'tracking-tight'], field.name)
            header.field = field.index
            container.children.push(header)
        }

        return container
    }

    createNavBar(classes) {
        return this.createContainerComponent('NavbarComponent', classes)
    }

    createButton(classes, text='Button') {
        let button = this.createTextComponent('ButtonComponent', classes, text)
        button.theme = ''
        return button
    }

    createList(classes) {
        return this.createContainerComponent('ListComponent', classes)
    }

    createListItem(classes) {
        return this.createContainerComponent('ListItemComponent', classes)
    }

    createImageComponent(classes, imageUrl) {
        return {
            type: 'ImageComponent',
            classes: classes,
            url: imageUrl,
            id: -1,
            location: '0'
        }
    }

    createFAIcon(classes) {
        return {
            type: 'FontAwesomeIcon',
            classes: classes,
            location: '0'
        }
    }

    createInputField(classes, labelClasses, text, type='text') {

        let container = this.createComponent(['mb-3'])
        let label = this.createTextComponent('LabelComponent', labelClasses, text)
        container.children.push(label)
        let input = this.createBasicComponent('InputComponent', classes)
        input.inputType = type
        container.children.push(input)
        return container
    }

    createFieldTextInput(classes, labelClasses, field) {
        let container = this.createComponent(['mb-3'])
        let label = this.createTextComponent('LabelComponent', labelClasses, field.name)
        container.children.push(label)
        let input = this.createBasicComponent('InputComponent', classes)
        input.inputType = 'text'
        input.field = field.index
        container.children.push(input)
        return container
    }

    createFieldFileInput(classes, labelClasses, field) {
        let container = this.createComponent(['mb-3'])
        let label = this.createTextComponent('LabelComponent', labelClasses, field.name)
        container.children.push(label)
        let input = this.createBasicComponent('FileInputComponent', classes)
        input.field = field.index
        container.children.push(input)
        return container
    }

    createFieldTextArea(classes, labelClasses, field) {
        let container = this.createComponent(['mb-3'])
        let label = this.createTextComponent('LabelComponent', labelClasses, field.name)
        container.children.push(label)
        let textComponent = this.createTextComponent('TextComponent', classes, '')
        textComponent.field = field.index
        container.children.push(textComponent)
        return container
    }

    createCheckbox(classes, text) {
        return this.createTextComponent('CheckboxComponent', classes, text)
    }

    createMobileNavLink(classes, url) {
        let link = this.createBasicComponent('MobileNavMenuIcon', classes)
        link.url = url
        return link
    }

    createIconLink(classes, iconClasses, url, text) {
        let link = this.createContainerComponent('LinkComponent', classes)
        link.url = url
        link.text = text
        let icon = this.createFAIcon(iconClasses)
        link.children.push(icon)
        return link
    }

    createLink(classes, text, url) {
        let link = this.createTextComponent('LinkComponent', classes, text)
        link.url = url
        link.resourceType = ''
        link.resource = ''
        link.resourceName = ''
        link.children = []
        link.theme = ''
        return link
    }

    createLabel(classes, text='Label') {
        let label = this.createTextWrapperComponent('LabelComponent', classes)
        label.isGradientColor = false
        let span = this.createTextComponent('SpanComponent', ['inline-block'], text)
        label.children.push(span)

        // label.style = {
        //     colorType: 'solid',
        //     color: this.colorFactory.createColorObject('slate', '800'),
        //     color2: this.colorFactory.createColorObject('slate', '900'),
        //     color3: null
        // }

        return label
    }

    createText(classes, textValue='This is some text') {
        return this.createTextComponent('TextComponent', classes, textValue)
    }

    createHeader(classes, text='Headline Text Here') {
        // let header = this.createTextComponent('HeaderComponent', classes, text)
        let header = this.createTextWrapperComponent('HeaderComponent', classes)
        header.element = 'h1'
        header.isGradientColor = false

        let span = this.createTextComponent('SpanComponent', ['inline-block'], text)
        header.children.push(span)

        // header.style = {
        //     colorType: 'solid',
        //     color: this.colorFactory.createColorObject('slate', '800'),
        //     color2: this.colorFactory.createColorObject('slate', '900'),
        //     color3: null
        // }

        return header
    }

    createContainerComponent(type, classes) {
        return {
            type: type,
            classes: classes,
            children: [],
            animation: webase.utils.animation.initAnimationProperty(),
            location: '0',
            theme: ''
        }
    }

    createBasicComponent(type, classes) {
        return {
            type: type,
            classes: classes,
            location: '0'
        }
    }

    createTextWrapperComponent(type, classes) {
        return {
            type: type,
            classes: classes,
            children: [],
            animation: webase.utils.animation.initAnimationProperty(),
            location: '0',
            font: ''
        }
    }

    createTextComponent(type, classes, text) {
        return {
            type: type,
            classes: classes,
            text: text,
            location: '0',
            font: ''
        }
    }
}